import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/terms/components/TermsBody/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/CommonLayout/index.tsx");
